import { connect } from 'react-redux';
import DanhSachKho from 'components/DanhSachKho';
import { getListDanhSachKho } from 'actions/DanhSachKho';
import { showModalStore } from 'actions/AddOrEditStore';
import { showDeleteModalStore } from 'actions/DeleteStore';

const mapStateToProps = (state) => ({
  danhsachkho: state.danhsachkho,
  user: state.user,
  addoreditstore: state.addoreditstore,
  deletestore: state.deletestore,
});

const mapDispatchToProps = (dispatch) => ({
  getListDanhSachKho: (dataSearch) => dispatch(getListDanhSachKho(dataSearch)),
  showModalStore: (data) => dispatch(showModalStore(data)),
  showDeleteModalStore: (data) => dispatch(showDeleteModalStore(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DanhSachKho);
